<template>
	<div>
		<ReceivableHead></ReceivableHead>
		<div class="flex filter_table">
			<AllReceivablesTable class="w_100"
								 :filters="filters"
			></AllReceivablesTable>
			<AllReceivablesFilter @apply-filter="applyFilter"/>
		</div>
	</div>
</template>

<script>
import AllReceivablesFilter from "@/components/templates/seller/receivables/AllReceivablesFilter";
import AllReceivablesTable from "@/components/templates/seller/receivables/AllReceivablesTable";
import ReceivableHead from "@/components/templates/seller/receivables/ReceivableHead";

export default {
	components: {
		AllReceivablesTable,
		AllReceivablesFilter,
		ReceivableHead
	},
	data() {
		return {
			filters: [],
		};
	},
	methods: {
		applyFilter(filters) {
			this.filters = filters;
		}
	}
};
</script>
